import React from 'react';
import { shape, string } from 'prop-types';
import Icon from 'components/icon';
// import Parser from 'html-react-parser';

export default function ContactLayout(props) {
    const { contact } = props;

    if (contact.name === '') return null;

    return (
        <div className="contact-layout">
            <div className="container">
                <p>
                    {contact.title && <strong>{contact.title}<br /></strong>}
                    {(contact.email && contact.name) && <a href={`mailto:${contact.email}`}><Icon glyph="email" />{contact.name}</a>}
                    {(!contact.email && contact.name) && <span>{contact.name}</span>}
                    <span className="as-div">
                        {contact.number1 && <span><a href={`tel:${contact.number1}`}><Icon glyph="phone" />{contact.number1}</a></span>}
                        {contact.number2 && <span className="second-number"><a href={`tel:${contact.number2}`}>{contact.number2}</a></span>}
                    </span>
                </p>
            </div>
        </div>
    );
}

ContactLayout.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    contact: shape({ title: string.isRequired }).isRequired
    /* eslint-enable react/no-typos */
};



// WEBPACK FOOTER //
// ./src/components/filtered-listing/layouts/ContactLayout.jsx